"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hcSessionContextGenerator = exports.hcSessionContextFilter = void 0;
const SP_USER_ID_MAX_LENGTH = 64;
const SP_SESSION_ID_MAX_LENGTH = 64;
function hcSessionContextFilter(dataProvider) {
    return () => {
        const data = dataProvider.readHcSessionContextData();
        return (data.userId != null &&
            data.sessionId != null &&
            data.userId.length <= SP_USER_ID_MAX_LENGTH &&
            data.sessionId.length <= SP_SESSION_ID_MAX_LENGTH);
    };
}
exports.hcSessionContextFilter = hcSessionContextFilter;
function hcSessionContextGenerator(dataProvider) {
    return () => {
        const data = dataProvider.readHcSessionContextData();
        return {
            schema: 'iglu:com.healthcare/ctx_tron_tracking/jsonschema/1-0-0',
            data: {
                user_id: data.userId,
                session_id: data.sessionId,
            },
        };
    };
}
exports.hcSessionContextGenerator = hcSessionContextGenerator;
//# sourceMappingURL=hc-session-global-context-generators.js.map